import { tableAnatomy } from '@chakra-ui/anatomy'
import { defineSlotRecipe } from '@chakra-ui/react'

export const tableRecipe = defineSlotRecipe({
  slots: tableAnatomy.keys,
  base: {},
})

// import { tableAnatomy } from '@chakra-ui/anatomy'
// import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

// const helper = createMultiStyleConfigHelpers(tableAnatomy.keys)

// const baseStyle = helper.definePartsStyle({})

// export const tableTheme = helper.defineMultiStyleConfig({
//   baseStyle,
// })
